import { observer } from "mobx-react-lite";
import ReactCountryFlag from "react-country-flag";
import LanguageStore from "../../store/LanguageStore";
import './language-selector.scss';
import { useState } from "react";

const LanguageSelector = observer(() => {
    const {language} = LanguageStore;
    const [showAllLangs, setShowAllLangs] = useState(false);
    const langList = ['ru', 'gb'];
    let flagListMeta = 'lang-selector__list';

    if (showAllLangs) {
        flagListMeta += ' show';
    }

    const toggleLangList = () => {
        setShowAllLangs(!showAllLangs);
    }

    const changeLang = (lang) => {
        LanguageStore.setLanguage(lang);
        toggleLangList();
        localStorage.setItem('currentLang', lang);
    }

    return (
        <div className="lang-selector" onClick={toggleLangList}>
            <ReactCountryFlag
                countryCode={language}
                svg
                className="lang-selector__flag"
                style={{
                    width: '40px',
                    height: 'auto'
                }}
            />

            <div className={flagListMeta}>
                {langList.map((element, index) => {
                    return <ReactCountryFlag
                        key={index}
                        countryCode={element}
                        svg
                        className="lang-selector__flag"
                        onClick={() => changeLang(element)}
                        style={{
                            width: '40px',
                            height: 'auto'
                        }}
                    />
                })}
            </div>
        </div>
    );
});

export default LanguageSelector;